import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'
import { Spacing } from 'zens-storybook'
import { Suspense } from 'react'
import { useNumberParams } from 'zens-router'
import { useBreadcrumb } from '@dms/hook'
import { BuildingInsights, LayoutHeader } from '@dms/component'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    marginHorizontal: Spacing.L,
    marginTop: Spacing.S,
    marginBottom: Spacing.L,
  },
  block: {
    marginTop: Spacing.M,
  },
})

const InsightsBuilding = () => {
  const { t } = useTranslation()
  const [{ companyId }] = useNumberParams()

  const breadcrumb = useBreadcrumb([
    {
      title: t('Insights'),
    },
  ])

  return (
    <View style={styles.container}>
      <LayoutHeader title={t('Insights')} breadcrumb={breadcrumb} />
      <View style={styles.content}>
        <Suspense fallback={<BuildingInsights.Skeleton style={styles.block} />}>
          <BuildingInsights companyId={companyId} style={styles.block} />
        </Suspense>
      </View>
    </View>
  )
}

export default InsightsBuilding
